import queryString from 'query-string'
import apiClient from './api-client'

function getDevices({ patientId }) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: 'devices',
      query: { patient_id: patientId },
    }),
  )
}

function updateDevice(id, deviceData) {
  return apiClient.patch(`devices/${id}`, deviceData)
}

function deleteDevice(id) {
  return apiClient.destroy(`devices/${id}`)
}

export default { getDevices, updateDevice, deleteDevice }
